// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { signOut } from '../../../../actions/authActions';
import { EMMA_DOMAIN_REGEX } from '@axa-asia/utils';

interface SignOutScreenProps {
  signOut: () => void;
}

interface SignOutScreenState {
  redirectUrl: any;
}

class SignOutScreen extends Component<SignOutScreenProps, SignOutScreenState> {
  constructor(props: SignOutScreenProps) {
    super(props);
    const initProps: any = props;
    const redirectUrlString = decodeURIComponent(
      initProps.location.search.replace('?redirectUrl=', ''),
    );
    let redirectUrl = '';
    if (redirectUrlString) {
      try {
        const redirectUrlObj = new URL(redirectUrlString);
        if (
          redirectUrlObj.hostname &&
          redirectUrlObj.hostname.match(EMMA_DOMAIN_REGEX)
        ) {
          redirectUrl = redirectUrlString;
        }
      } catch (e) {
        console.error('Invalid signout redirect url', e);
      }
    }
    this.state = {
      redirectUrl,
    };
  }

  componentDidMount() {
    this.props.signOut();
    // if no redirect url, default back to login screen
    if (this.state.redirectUrl) {
      setTimeout(() => {
        window.location.href = this.state.redirectUrl;
      }, 500);
    }
  }

  render() {
    return <div></div>;
  }
}

const mapStateToProps = (state: any) => {
  return {};
};

const mapDispatchToProps = (dispatch: any) => ({
  signOut: () => dispatch(signOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignOutScreen);
